import _SdCommonModelComputation from "../commons/SdCommonModelComputation";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverResponseModelComputationStatus = void 0;
const SdCommonModelComputation_1 = _SdCommonModelComputation;
exports.ShapeDiverResponseModelComputationStatus = Object.assign({}, SdCommonModelComputation_1.ShapeDiverCommonsModelComputationStatus);
//# sourceMappingURL=SdResponseDtoModelComputation.js.map
export default exports;